import {createContext} from "react"

interface Config{
    client_name : string,
    client_display_name : string,
    modal_confirm_button_label : string,
    country : 'de' | 'at' | 'ch',
    base_asset_url : string,
    plz_validation : (plz : string) => boolean,
    foerderung : boolean,
    uid?: string,
    contact_url?: string,
    logo_url?: string,
    menu_items_sorting?: Array<string>,
    plus_expanded?: boolean,
    show_geg_info: boolean,
    one_click_house_type: boolean,
}

export const ConfigContext = createContext<Config>({
    client_name : "febis",
    client_display_name : "Febis",
    modal_confirm_button_label : "übernehmen",
    country : 'at',
    base_asset_url :` https://esr.fe-bis.de/at/febis/`,
    plz_validation : (plz : string) => plz.length == 4,
    foerderung : false,
    menu_items_sorting: undefined,
    plus_expanded: false,
    show_geg_info: true,
    one_click_house_type: false,
});


